import './App.css';
import DefaultLayout from './components/templates/DefaultLayout';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <DefaultLayout/>
      </div>
    </LanguageProvider>
  );
}

export default App;
